import { Language } from './type';

export function defineLanguage(config: Language): Language {
  return Object.freeze(config); // Immutability at runtime
}
